module.exports = __webpack_public_path__ + "static/media/voordeur.c2fa37c9.jpg";